import store from "@/store";
import { $loaderService } from "@/plugins/ELoaderService";
import authService from "@/Services/AuthService";

const redirecionarSeForProfAuxiliar = async (to, from, next) => {
  let currentUser = store.getters["Auth/user"];

  if (!currentUser) {
    await $loaderService.loadBasicDataIfNeeded();
  }

  currentUser = store.getters["Auth/user"];

  if (!currentUser) {
    next({ name: "login" });
    return;
  }

  if (currentUser.roleName === "prof-auxiliar") {
    try {
      const tipos = await authService.getTiposAcessoProfessor();
      if (tipos.pode_diario_online && tipos.pode_diario_auxiliar) {
        next();
      } else if (tipos.pode_diario_auxiliar) {
        next({ name: "gestoesDeAulasAuxiliares" });
      } else if (tipos.pode_diario_online) {
        next({ name: "gestoesDeAulas" });
      } else {
        next({ name: "acessoProfessor.home" });
      }
    } catch (error) {
      next({ name: "gestoesDeAulasAuxiliares" });
    }
    return;
  }

  next();
};

export default redirecionarSeForProfAuxiliar;
